import { useEffect } from 'react';
import { useSiteSettings } from '@/contexts/SiteSettingsContext';

/**
 * Injects Google Analytics 4 + Meta Pixel when their IDs are configured in admin settings.
 * Renders nothing.
 */
export default function AnalyticsInjector() {
  const { settings } = useSiteSettings();

  useEffect(() => {
    if (!settings) return;
    const ga = (settings.google_analytics_id || '').trim();
    const pixel = (settings.meta_pixel_id || '').trim();

    // Strict allow-list: GA4 ids = "G-XXXXXX", Meta Pixel ids = numeric only.
    // Prevents any injected characters from breaking out of the script body.
    const isValidGa = /^G-[A-Z0-9]{4,20}$/i.test(ga);
    const isValidPixel = /^\d{6,20}$/.test(pixel);

    if (isValidGa && !document.getElementById('ga4-script')) {
      const s1 = document.createElement('script');
      s1.id = 'ga4-script';
      s1.async = true;
      s1.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ga)}`;
      document.head.appendChild(s1);
      const s2 = document.createElement('script');
      s2.id = 'ga4-inline';
      // Use textContent (not innerHTML) — IDs already passed regex allow-list.
      s2.textContent = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config',${JSON.stringify(ga)});`;
      document.head.appendChild(s2);
    }

    if (isValidPixel && !document.getElementById('meta-pixel')) {
      const s = document.createElement('script');
      s.id = 'meta-pixel';
      s.textContent = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init',${JSON.stringify(pixel)});fbq('track','PageView');`;
      document.head.appendChild(s);
    }
  }, [settings]);

  return null;
}
